import { type ReactNode } from 'react'
import { Text, View } from 'react-native'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/utils/cn'

const viewVariants = cva('rounded bg-fill-subtle px-2 py-0.5', {
  variants: {
    mood: {
      neutral: 'bg-fill-light',
      success: 'bg-success-light',
      error: 'bg-danger-light',
      info: 'bg-info-light',
      warning: 'bg-warning-light'
    }
  },
  defaultVariants: {
    mood: 'neutral'
  }
})

const textVariants = cva('text-sm', {
  variants: {
    mood: {
      neutral: 'text-text-secondary',
      success: 'text-text-success',
      error: 'text-text-danger',
      info: 'text-text-info',
      warning: 'text-text-warning'
    }
  },
  defaultVariants: {
    mood: 'neutral'
  }
})

type TagVariants = VariantProps<typeof viewVariants>

export const Tag = ({ children, mood }: { children: ReactNode; mood: TagVariants['mood'] }) => {
  return (
    <View className={cn(viewVariants({ mood }))}>
      <Text className={cn(textVariants({ mood }))}>{children}</Text>
    </View>
  )
}
